// The daily bonus celebration: a chest you tap open, the prize revealed
// underneath it, coins flying from its mouth to the bux counter in the user
// bar, and the counter ticking up as they land.
//
// External file (not inline) because the CSP allows only 'self' scripts.

const COIN_COUNT = 12
// Nobody should be able to get stuck staring at a closed chest — if they
// haven't tapped by now, open it for them.
const AUTO_OPEN_MS = 6000

function flyCoins(card, claim) {
  const target = document.querySelector('.bux-amount')
  const chest = card.querySelector('.dbp-chest') || card
  const box = chest.getBoundingClientRect()
  // The mouth of the chest, not its centre: the coins should look like
  // they're coming out from under the lid.
  const start = { x: box.left + box.width / 2, y: box.top + box.height * 0.36 }
  // No counter on screen (signed-out chrome, narrow layouts): coins arc up
  // and fade rather than flying nowhere.
  const to = target
    ? (() => { const r = target.getBoundingClientRect(); return { x: r.left + r.width / 2, y: r.top + r.height / 2 } })()
    : { x: start.x, y: -80 }

  for (let i = 0; i < COIN_COUNT; i += 1) {
    const coin = document.createElement('span')
    coin.className = 'dbp-coin'
    coin.style.left = `${start.x}px`
    coin.style.top = `${start.y}px`
    // Each coin gets its own arc and timing so the burst doesn't read as one
    // rigid block.
    const spread = (Math.random() - 0.5) * 160
    coin.style.setProperty('--dbp-dx', `${to.x - start.x + spread * 0.25}px`)
    coin.style.setProperty('--dbp-dy', `${to.y - start.y}px`)
    coin.style.setProperty('--dbp-lift', `${-90 - Math.random() * 70}px`)
    coin.style.setProperty('--dbp-spread', `${spread}px`)
    coin.style.animationDelay = `${i * 55}ms`
    document.body.appendChild(coin)
    coin.addEventListener('animationend', () => coin.remove())
  }

  if (target && typeof claim.balance === 'number') {
    tickCounter(target, claim)
  }
}

// Count the visible balance up while the coins land.
function tickCounter(target, claim) {
  const end = claim.balance
  const begin = Math.max(0, end - claim.amount)
  const duration = 900
  const startedAt = performance.now()
  target.classList.add('dbp-counting')

  const step = (now) => {
    const t = Math.min(1, (now - startedAt) / duration)
    const eased = 1 - Math.pow(1 - t, 3)
    target.textContent = Math.round(begin + (end - begin) * eased).toLocaleString()
    if (t < 1) requestAnimationFrame(step)
    else target.classList.remove('dbp-counting')
  }
  setTimeout(() => requestAnimationFrame(step), 300)
}

function closePopup(overlay) {
  overlay.classList.add('dbp-leaving')
  overlay.addEventListener('animationend', () => overlay.remove(), { once: true })
  setTimeout(() => overlay.remove(), 600)
}

// Tell the server the animation actually played, so the celebration isn't
// owed any more. Until this lands the popup will reappear on the next visit —
// which is the point: a claim in a background tab still gets celebrated.
function markSeen() {
  const csrf = document.querySelector('meta[name="csrf-token"]')?.content
  fetch('/account/daily_bonus_seen', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf },
    keepalive: true,
  }).catch(() => {})
}

function initDailyBonus() {
  const overlay = document.getElementById('daily-bonus-pop')
  if (!overlay || overlay.dataset.ran) return
  overlay.dataset.ran = '1'

  let claim = {}
  try { claim = JSON.parse(overlay.dataset.claim || '{}') } catch (e) { /* defaults */ }

  const card = overlay.querySelector('.dbp-card')
  const stage = overlay.querySelector('.dbp-stage')
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches

  requestAnimationFrame(() => overlay.classList.add('dbp-open'))
  // Only once it's actually on screen — a hidden background tab hasn't
  // celebrated anything.
  if (document.visibilityState === 'visible') markSeen()
  else document.addEventListener('visibilitychange', function once() {
    if (document.visibilityState !== 'visible') return
    markSeen()
    document.removeEventListener('visibilitychange', once)
  })

  let autoOpen = null
  const openChest = () => {
    if (card.classList.contains('dbp-opened')) return
    clearTimeout(autoOpen)
    card.classList.remove('dbp-idle')
    card.classList.add('dbp-opened')
    if (!reduced) setTimeout(() => flyCoins(card, claim), 320)
  }

  if (reduced) {
    // No lid animation to wait on, and no coins: show the whole thing at once
    // and put the new balance straight on the counter.
    card.classList.remove('dbp-idle')
    card.classList.add('dbp-opened')
    const target = document.querySelector('.bux-amount')
    if (target && typeof claim.balance === 'number') target.textContent = claim.balance.toLocaleString()
  } else {
    stage.addEventListener('click', openChest)
    stage.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); openChest() }
    })
    autoOpen = setTimeout(openChest, AUTO_OPEN_MS)
  }

  overlay.querySelectorAll('.dbp-close, .dbp-ok').forEach((btn) => {
    btn.addEventListener('click', (event) => { event.stopPropagation(); closePopup(overlay) })
  })
  overlay.addEventListener('click', (event) => {
    if (event.target === overlay) closePopup(overlay)
  })
  document.addEventListener('keydown', function onKey(event) {
    if (event.key !== 'Escape') return
    closePopup(overlay)
    document.removeEventListener('keydown', onKey)
  })
}

document.addEventListener('turbo:load', initDailyBonus)
document.addEventListener('DOMContentLoaded', initDailyBonus)
